import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { advertismentCommand } from '../../model/const/command';
import { LettingAdvertismentPremisesService } from '../letting-advertisment-premises.service';

@Injectable()
export class SendToPlatformPremisesCommandHandler implements ICommandHandler {
  constructor(private _advertService: LettingAdvertismentPremisesService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === advertismentCommand.sendToPlatform && command.context;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return this._advertService.sendToPlatform(command.context.id);
    }
  }
}
